import { FormControlLabel, Switch } from '@mui/material';
import { DateNavigation } from 'components/shared';
import PlanUnitSelector from 'components/shared/PlanUnitSelector';
import type { SingleOrRange } from 'components/shared/DateNavigation/DateNavigation.types';
import { useTranslation } from 'react-i18next';
import { toNativeDate } from 'utils/date';
import {
  DateNavigationContainer,
  PlanUnitSelectorContainer,
  StyledHeader,
  Top
} from './Header.styles';
import type { HeaderProps } from './Header.types';

const Header = ({
  selectedDate,
  selectedDateRange,
  period,
  onlyToApprove,
  onPeriodChange,
  onSelectedDate,
  onSelectedDateRange,
  onSelectPlanUnit,
  onOnlyToApproveChange
}: HeaderProps) => {
  'use memo';

  const { t } = useTranslation('common');

  const handleSelectedDateChange = (date: SingleOrRange) => {
    if (period === 'custom') {
      onSelectedDateRange(Array.isArray(date) ? date : undefined);
      return;
    }

    if (Array.isArray(date)) {
      onSelectedDate(toNativeDate(date[0]));
      return;
    }

    onSelectedDate(toNativeDate(date));
  };

  return (
    <StyledHeader as="header">
      <Top>
        <PlanUnitSelectorContainer>
          <PlanUnitSelector onSelected={onSelectPlanUnit} />
          <FormControlLabel
            control={
              <Switch
                checked={onlyToApprove}
                onChange={(_, checked) => onOnlyToApproveChange(checked)}
              />
            }
            label={t('hoursPayOutRequestsOverview.toBeApproved')}
          />
        </PlanUnitSelectorContainer>

        <DateNavigationContainer>
          <DateNavigation
            defaultPeriod="custom"
            options={['month', 'custom']}
            defaultDate={selectedDate}
            defaultDateRange={selectedDateRange}
            onDateChange={handleSelectedDateChange}
            onPeriodChange={onPeriodChange}
            allowMenuOptions
            persistPeriodPreference={false}
          />
        </DateNavigationContainer>
      </Top>
    </StyledHeader>
  );
};

export default Header;
